// Registrar status of a domain. Unknown statuses (kept as the registrar
// reports them) render neutrally with their own name.

const STYLES: Record<string, { label: string; className: string }> = {
  active: { label: 'active', className: 'bg-green-100 text-green-700' },
  expired: { label: 'expired', className: 'bg-red-100 text-red-700' },
  locked: { label: 'locked', className: 'bg-yellow-100 text-yellow-700' },
  pending_transfer: { label: 'pending transfer', className: 'bg-blue-100 text-blue-700' },
  pending: { label: 'updating', className: 'bg-blue-100 text-blue-700' },
  transferred_out: { label: 'transferred out', className: 'bg-slate-200 text-slate-700 line-through decoration-slate-400' },
  transfer_failed: { label: 'transfer failed', className: 'bg-orange-100 text-orange-800' },
};

export default function DomainStatusBadge({ status, size = 'md', registrarStatus }: { status: string | null | undefined; size?: 'sm' | 'md'; registrarStatus?: string | null }) {
  const s = status || 'unknown';
  const meta = STYLES[s] ?? { label: s.replace(/_/g, ' '), className: 'bg-slate-100 text-slate-700' };
  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2 py-1 text-xs'} ${meta.className}`}
      title={[
        s === 'transferred_out' ? 'No longer held by this registrar account' : s === 'transfer_failed' ? 'The transfer into this registrar account failed — the account never held it' : null,
        registrarStatus ? `Registrar status: ${registrarStatus}` : null,
      ].filter(Boolean).join('\n') || undefined}
    >
      {meta.label}
    </span>
  );
}
